import { IUserType } from "@state/auth/types";
import { IDesignAuth, PermissionEnum, UserData } from "@state/designs/types";
import { Profile } from "oidc-client";

export const getUserPermission = (owner?: UserData, profile?: Profile, designAuth?: IDesignAuth, loginWithToken?: boolean) => {
  let permission: PermissionEnum = PermissionEnum.PUBLIC_VIEW;
  if (profile && profile.role !== IUserType.PUBLIC) {
    if (profile.role === IUserType.ADMIN || profile.email === owner?.email) permission = PermissionEnum.EDIT;
    else {
      permission = loginWithToken ? PermissionEnum.PUBLIC_VIEW : PermissionEnum.NONE;
      designAuth?.usersPermission?.map(userPermission => {
        if (userPermission.email === profile.email) permission = userPermission.permission;
      });
    }
  }
  return permission;
}